/* eslint-disable max-len */
const availableProjects =
  [
    require('../../../provision/projects/pixel sketch/pixel sketch.json'),
    require('../../../provision/projects/bubble pop/bubble pop.json'),
    require('../../../provision/projects/fuzzy face/fuzzy face.json'),
    require('../../../provision/projects/match the beat/match the beat.json'),
    require('../../../provision/projects/fruit catcher/fruit catcher.json'),
    require('../../../provision/projects/makey soccer/makey soccer.json'),
    require('../../../provision/projects/alarm/alarm.json'),
    require('../../../provision/projects/buzzer/buzzer.json'),
    require('../../../provision/projects/counter/counter.json'),
    require('../../../provision/projects/is it conductive/is it conductive.json'),
    require('../../../provision/projects/make-a-sketch/make-a-sketch.json'),
    require('../../../provision/projects/piano/piano.json'),
    require('../../../provision/projects/scoreboard/scoreboard.json'),
    require('../../../provision/projects/timer/timer.json')


  ]

module.exports = availableProjects
